module.exports = __webpack_public_path__ + "static/img/dl_Keplr.9ba0572f.png";